import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';
import replaceWithCDN from '../../util/replaceWithCDN';
export default data => {
  const gridArr = get(data, 'eigItems', []);
  return {
    background: get(data, 'eigBackground', null),
    pretitle: get(data, 'eigPretitle', null),
    title: get(data, 'eigTitle', null),
    data: gridArr.map(item => {
      const catAssets = get(item, 'assets', []);
      return {
        category: get(item, 'category', ''),
        tour: get(item, 'tour', ''),
        assets: catAssets.map(item => {
          const image = get(item, 'eigImage', null) ? refactorRespImg(get(item, 'eigImage', null), [{
                size: 'default',
                key: 'image_size_375x451',
              },
              {
                size: 'md',
                key: 'image_size_1595x745',
              }]
          ) : null;
          return {
            image: image,
            iframe: get(item, 'iframe', ''),
            video: replaceWithCDN(get(item, 'videoFile.guid', ''))
            //video: get(item, 'video', '')
          }
        })
      }
    })
  }
}

/*
    "data": {
      "pretitle": "dolore quis pariatur aute est",
      "title": "sit nulla laborum",
      "data": [
        {
          "category": "veniam nisi do",
          "assets": [
            {
              "image": {
                "alt": "mollit",
                "sizes": {
                  "default": {
                    "width": 375,
                    "height": 451,
                    "jpg": "//unsplash.it/375/451.jpg?random&gravity=center&rand=564631",
                    "webp": "//unsplash.it/375/451.webp?random&gravity=center&rand=384281"
                  },
                  "md": {
                    "width": 1600,
                    "height": 750,
                    "jpg": "//unsplash.it/1600/750.jpg?random&gravity=center&rand=347691",
                    "webp": "//unsplash.it/1600/750.webp?random&gravity=center&rand=192451"
                  }
                }
              },
              "video": "http://cdn.vi.com.au/studio/placeholdervideos/2.mp4"
            },
            {
              "image": {
                "alt": "minim",
                "sizes": {
                  "default": {
                    "width": 375,
                    "height": 451,
                    "jpg": "//unsplash.it/375/451.jpg?random&gravity=center&rand=564631",
                    "webp": "//unsplash.it/375/451.webp?random&gravity=center&rand=384281"
                  },
                  "md": {
                    "width": 1600,
                    "height": 750,
                    "jpg": "//unsplash.it/1600/750.jpg?random&gravity=center&rand=347691",
                    "webp": "//unsplash.it/1600/750.webp?random&gravity=center&rand=192451"
                  }
                }
              },
              "iframe": "https://my.matterport.com/show/?m=kusL9NuEuQS",
              "video": "http://cdn.vi.com.au/studio/placeholdervideos/2.mp4"
            },
          ],
          "tour": true
        },
        {
          "category": "ullamco",
          "assets": [
            {
              "image": {
                "alt": "Ut deserunt",
                "sizes": {
                  "default": {
                    "width": 375,
                    "height": 451,
                    "jpg": "//unsplash.it/375/451.jpg?random&gravity=center&rand=564631",
                    "webp": "//unsplash.it/375/451.webp?random&gravity=center&rand=384281"
                  },
                  "md": {
                    "width": 1600,
                    "height": 750,
                    "jpg": "//unsplash.it/1600/750.jpg?random&gravity=center&rand=347691",
                    "webp": "//unsplash.it/1600/750.webp?random&gravity=center&rand=192451"
                  }
                }
              },
              "video": "http://cdn.vi.com.au/studio/placeholdervideos/2.mp4",
              "iframe": "https://my.matterport.com/show/?m=kusL9NuEuQS"
            },
          ],
          "tour": true
        },
      ],
      "background": "dark"
    }
  },
*/

/*
          {
            "fieldGroupName": "Series_AcfSeriesContentBuilder_ContentBuilder_FcEnrichedImageGallery",
            "collapseSpacing": {
              "top": null,
              "bottom": null
            },
            "eigBackground": "light",
            "eigPretitle": "EIG Pretitle",
            "eigTitle": "EIG title",
            "eigItems": [
              {
                "category": "Category 1",
                "tour": true,
                "assets": [
                  {
                    "eigImage": {
                      "guid": "https://gc3deb9d-sb-assets-t441d948-sp.s3.amazonaws.com/2020/06/dummy_1600x750_ffffff_1a9aef-sm-1685583787.png"
                    },
                    "iframe": "some iframe code",
                    "video": "http://cdn.vi.com.au/studio/placeholdervideos/2.mp4"
                  },
                  {
                    "eigImage": {
                      "guid": "https://gc3deb9d-sb-assets-t441d948-sp.s3.amazonaws.com/2020/06/dummy_1600x750_ffffff_1a9aef-sm-1685583787.png"
                    },
                    "iframe": "some iframe code 2",
                    "video": "http://cdn.vi.com.au/studio/placeholdervideos/2.mp4"
                  }
                ]
              },
              {
                "category": "Category 2",
                "tour": true,
                "assets": [
                  {
                    "eigImage": {
                      "guid": "https://gc3deb9d-sb-assets-t441d948-sp.s3.amazonaws.com/2020/06/dummy_1600x750_ffffff_1a9aef-sm-1685583787.png"
                    },
                    "iframe": "iframe 3",
                    "video": "http://cdn.vi.com.au/studio/placeholdervideos/2.mp4"
                  }
                ]
              }
            ]
          }
*/